import { useEffect, useState } from "react";
import * as React from 'react';
import Thumbs from "./Thumbs";

const CustomStreamingTextCard = (props: any) => {
    const { text } = props;
    const { id } = props;
    const { showthumb } = props;
    const { msgfeedback } = props;
    const [thum, setThum] = useState(true);
    const [thumbsu, setThumbsu] = useState(false);
    const [thumbsd, setThumbsd] = useState(false);
    var show;
    var tab = -1;
    var rol = "";
    var aria: "off" | "polite" | "assertive" = "off";

    var feedbackclick = (selection: any, msguid: any) => {
        msgfeedback(selection, id);


    }
    if (showthumb === true) {

        show = true;
        tab = 0;
        rol = "presentation";
        aria = "polite";
    }
    else {
        tab = -1;
        rol = "";
        aria = "off";
    }
    const [message, setMessage] = useState('');
    useEffect(() => {
        setMessage(text)
    }, [text]);

    const urldetect = /(https?:\/\/[^\s]+)/g;

    const chunk = text.split(urldetect);

    const removeDot = (inputval: any) => {
        if (inputval.endsWith(".")) {
            return inputval.slice(0, -1);
        } else {
            return inputval;
        }
    }

    return (
        <div>
            <div className="chat-message" tabIndex={tab} role={rol} aria-live={aria}><p>

                {
                    chunk.map((chunk: any, index: any) => {

                        if (chunk.match(urldetect)) {

                            var refinedURL = removeDot(chunk);

                            return (
                                <a className="chat-link-url" key={index} href={refinedURL} target="_blank">{refinedURL}</a>
                            )
                        }
                        else {
                            return (

                                <span key={index}>{chunk}</span>

                            )
                        }

                    })
                }



            </p>

            </div>
            {
                show && <div id={id} className="feedback">

                    <Thumbs idno={id} feedbclick={feedbackclick} />

                </div>
            }



        </div>
    );
}
export default CustomStreamingTextCard;
